import React, { Component } from "react";

import { I18nextProvider, withTranslation } from "react-i18next";

import i18next from "../../i18next";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function withTrans(WrappedComponent: any) {
  WrappedComponent = withTranslation()(WrappedComponent);

  return class WithTrans extends Component {
    render() {
      return (
        <I18nextProvider i18n={i18next}>
          <WrappedComponent {...this.props} language={i18next.language} />
        </I18nextProvider>
      );
    }
  };
}
